import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "card-header",
  id: "kt_explore_header"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-gray-700" }, "طباعة التقارير", -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-active-light-primary me-n5",
  id: "SideBarPrint_close"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = {
  class: "card-body",
  id: "kt_explore_body"
}
const _hoisted_7 = { class: "d-flex align-items-center position-relative my-1 me-5 form-label text-dark col-md-12" }
const _hoisted_8 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mt-8 mb-5" }, null, -1)
const _hoisted_10 = { class: "navi navi-hover navi-active navi-link-rounded navi-bold navi-icon-center navi-light-icon" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "navi-icon mr-4 m-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fad fa-print text-primary" })
], -1)
const _hoisted_13 = { class: "navi-text font-weight-bolder font-size-lg" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-items-center bg-light-success rounded p-5 gutter-b"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-grow-1 mr-2" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "font-weight-normal text-dark-75 text-hover-primary font-size-lg mb-1" }, "لا يوجد تقارير متاحة"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted font-size-sm" }, "لانشاء تقارير جديدة برجاء الضغط على انشاء تقرير")
], -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_n_drawer = _resolveComponent("n-drawer")!

  return (_openBlock(), _createBlock(_component_n_drawer, {
    "on-after-enter": _ctx.handleOpen,
    show: _ctx.drawer,
    "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.drawer) = $event)),
    "on-update:show": _ctx.toggleDrawer,
    title: "التقارير",
    resizable: "",
    placement: "left",
    "default-width": 500
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        style: _normalizeStyle(`direction:${_ctx.Direction} !important ;`),
        class: "card shadow-none w-100"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args))),
              onKeypress: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args))),
              type: "text",
              "data-kt-permissions-table-filter": "search",
              class: "form-control form-control-solid ps-15",
              placeholder: "بحث عن تقرير"
            }, null, 544), [
              [_vModelText, _ctx.search]
            ])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfReports, (i, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "navi-item my-2",
                key: 'A' + index
              }, [
                _createElementVNode("a", {
                  class: "navi-link link m-2",
                  onClick: ($event: any) => (_ctx.onPrintReport({ id: i.reportId, name: i.name }))
                }, [
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, _toDisplayString(i.name), 1)
                ], 8, _hoisted_11)
              ]))
            }), 128)),
            (_ctx.listOfReports.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
              : _createCommentVNode("", true)
          ])
        ])
      ], 4)
    ]),
    _: 1
  }, 8, ["on-after-enter", "show", "on-update:show"]))
}